import { TextRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasPickerContribution, CanvasTextPicker } from "../constants";

import { DefaultCanvasTextPicker } from "./text-picker";

let loadTextPick = !1;

export function bindTextCanvasPickerContribution(container) {
    loadTextPick || (loadTextPick = !0, container.bind(CanvasTextPicker).toDynamicValue((() => new DefaultCanvasTextPicker(resolveContainerBinding(container, TextRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasTextPicker));
}
//# sourceMappingURL=text-module.js.map
